
import tsomgoImg from "../images/Carousel/buddhapark.jpg";
import gtk from "../images/Carousel/gangtok.jpg";
import tashi from "../images/ExploreEast/Tashi.jpeg";
import ganesh from "../images/ExploreEast/GaneshTok.jpeg";
import hanuman from "../images/ExploreEast/HanumanTok.jpeg";
import tsomgo from "../images/Carousel/tsomgo.jpg";
import nathula from "../images/ExploreNorth/Nathula.jpeg";
import chardham from "../images/ExploreWestnSouth/CharDham.jpeg";
import samdruptse from "../images/ExploreWestnSouth/Samdtuptse.jpeg";
import airport from "../images/ExploreEast/airport.png";
import sillery from "../images/ExploreEast/Sillery.png";
import zuluk from "../images/ExploreEast/zuluk.png";
import nathang from "../images/ExploreEast/Nathang.png";
import chunthang from "../images/ExploreNorth/Chungthang.jpeg";
import gurudongmar from "../images/ExploreNorth/Gurudongmar.jpeg";
import lachen from "../images/ExploreNorth/Lachen.jpeg";
import lachung from "../images/ExploreNorth/Lachung.jpeg";
import zeropoint from "../images/ExploreNorth/ZeroPoint.png";
import yumthang from "../images/ExploreNorth/Yumthang.jpeg";
import skywalk1 from "../images/ExploreWestnSouth/Sky Walk1.png";
import rimbi from "../images/ExploreWestnSouth/Rimbi.png";
import Khecheopalri from "../images/ExploreWestnSouth/Khecheopalri.png";
import ralang from "../images/ExploreWestnSouth/Ralang.png";
import buddha from "../images/ExploreWestnSouth/Buddha.jpeg";
import peace from "../images/ExploreDarjeeling/PeacePagoda.jpeg";
import zoo from "../images/ExploreDarjeeling/Zoo.png";
import batasia from "../images/ExploreDarjeeling/BatasiaLoop.jpeg";
import ghoom from "../images/ExploreDarjeeling/GhoomMonastery.jpeg";



export const itineraryDetails = {
  "tsomgo-lake-&-nathula-pass": [
    {
    day: "01",
    route: "New Jalpaiguri or Bagdogra → Gangtok",
    title: "GANGTOK",
    description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, and proceed to the beautiful hill town of Gangtok, the capital city of Sikkim. The journey takes approximately 4–5 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: ["Evening free to explore:", "1. M.G. Marg - A popular walking street known for its shops, cozy cafés, and lively nightlife."],
    images: [gtk],
    stay: "Gangtok",
    },
    {
    day: "02",
    route: "GANGTOK LOCAL SIGHT SEEING",
    title: "LOCAL SIGHT SEEING",
    description: "Gangtok local sightseeing offers a wonderful mix of natural beauty, peaceful temples, and cultural attractions.",
    points: [
    "Places of Sightseeing:",
    "1. Tashi View Point – Offers stunning panoramic views of the majestic Kanchenjunga mountain range, especially during sunrise.",
    "2. Ganesh Tok and Hanuman Tok – peaceful temples dedicated to Lord Ganesha and Lord Hanuman, known for their calm surroundings and beautiful views of Gangtok city.",
    "3. Enchey Monastery – A historic Buddhist monastery known for its spiritual significance and traditional architecture.",
    "4. Namgyal Institute of Tibetology – A renowned center for Tibetan studies, showcasing rare manuscripts, artifacts, and rich cultural heritage.",
    "5. Do Drul Chorten – One of the most important stupas in Gangtok, surrounded by prayer wheels and known for its religious importance.",
    "6. Banjhakri Falls – A beautiful waterfall set amidst landscaped gardens, associated with local shamanic traditions and folklore."
    ],
    images: [tashi, hanuman],
    stay: "Gangtok",
    },
    {
    day: "03",
    route: "GANGTOK → TSOMGO LAKE & NATHULA PASS",
    title: "TSOMGO LAKE & NATHULA PASS",
    description: "Embark on an early morning excursion to explore high-altitude attractions, where you can experience breathtaking mountain views, fresh crisp air, and the serene beauty of the Himalayan landscape.",
    points: [
    "Attraction:",
    "1. Tsomgo Lake (also called Changu Lake) – A beautiful glacial lake located at 12,400 ft.",
    "2. Nathula Pass – Historic mountain pass on the Indo-China border.",
    "3. Baba Harbhajan Singh Temple – A revered shrine dedicated to an Indian Army soldier, believed to safeguard and protect the region."
    ],
    images: [tsomgo, nathula],
    stay: "Gangtok",
    },
    {
    day: "04",
    route: "TSOMGO LAKE & NATHULA PASS → NEW JALPAIGURI OR BAGDOGRA",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After a memorable day exploring the snow-clad hills, enjoy a comfortable drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward journey. Your journey comes to a delightful end, leaving you with cherished memories of the breathtaking landscapes, serene mountain villages, and unforgettable experiences across Sikkim.",
    points: ["From the thrilling journey to Nathula Pass to the serene beauty of Tsomgo Lake, this tour offers unforgettable moments that stay with you long after you return."],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],

  "gangtok": [
   {
    day: "01",
    route: "New Jalpaiguri or Bagdogra → Gangtok",
    title: "GANGTOK",
    description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, and proceed to the beautiful hill town of Gangtok, the capital city of Sikkim. The journey takes approximately 4–5 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: ["Evening free to explore:", "1. M.G. Marg - A popular walking street known for its shops, cozy cafés, and lively nightlife."],
    images: [gtk],
    stay: "Gangtok",
    },
    {
    day: "02",
    route: "GANGTOK LOCAL SIGHT SEEING",
    title: "LOCAL SIGHT SEEING",
    description: "Gangtok local sightseeing offers a wonderful mix of natural beauty, peaceful temples, and cultural attractions.",
    points: [
    "Places of Sightseeing:",
    "1. Tashi View Point – Offers stunning panoramic views of the majestic Kanchenjunga mountain range, especially during sunrise.",
    "2. Ganesh Tok and Hanuman Tok – peaceful temples dedicated to Lord Ganesha and Lord Hanuman, known for their calm surroundings and beautiful views of Gangtok city.",
    "3. Enchey Monastery – A historic Buddhist monastery known for its spiritual significance and traditional architecture.",
    "4. Namgyal Institute of Tibetology – A renowned center for Tibetan studies, showcasing rare manuscripts, artifacts, and rich cultural heritage.",
    "5. Do Drul Chorten – One of the most important stupas in Gangtok, surrounded by prayer wheels and known for its religious importance.",
    "6. Banjhakri Falls – A beautiful waterfall set amidst landscaped gardens, associated with local shamanic traditions and folklore."
    ],
    images: [tashi, hanuman],
    stay: "Gangtok",
    },
    {
    day: "03",
    route: "Gangtok → New Jalpaiguri or Bagdogra",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After breakfast, enjoy a smooth drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward travel. Your journey comes to a delightful end, leaving you with cherished memories of the breathtaking landscapes, serene mountain villages, and unforgettable experiences across Sikkim.",
    points: ["From scenic viewpoints and peaceful temples to the lively MG Marg, Gangtok sightseeing gives you memories that stay even after your trip ends."],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],
   "old-silk-route": [
    {
      day: "01",
      route: "New Jalpaiguri or Bagdogra → Sillery Gaon",
      title: "Sillery Goan - New Darjeeling",
      description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, followed by a scenic drive to the peaceful village of Sillery Gaon, also known as the “New Darjeeling.”",
      points: ["Attractions:", "1. Breathtaking panoramic views of the Kanchenjunga range", "2. Peaceful walks through scenic pine forests", "3. Stunning sunrise and sunset viewpoints"],
      images: [sillery],
      stay: "Sillary Goan",
    },
    {
      day: "02",
      route: "Sillery Goan → Zuluk",
      title: "Zuluk (Old Silk Route)",
      description: "After breakfast, embark on a scenic drive to the historic village of Zuluk, a charming Himalayan destination nestled along the Old Silk Route, known for its winding roads and breathtaking mountain views.",
      points: ["En-route Sightseeing:", "1. Rongli – The official entry point to the Silk Route, known for its serene surroundings.", "2. Lingtham – Offers picturesque valley views and a peaceful Himalayan atmosphere.", "3. Padamchen – A quiet village nestled amidst dense forests and natural beauty."],
      images: [zuluk],
      stay: "Zuluk",
    },
    {
    day: "03",
    route: "Zuluk → Nathang Valley",
    title: "NATHANG VALLEY",
    description: "Begin your day with an early morning drive to Thambi View Point, a popular vantage spot known for its breathtaking panoramic views of the iconic zig-zag roads of the Silk Route. Later proceed to Gangtok.",
    points: ["Continue Sightseeing:", "1. Nathang Valley – Often referred to as the “Ladakh of East Sikkim”.", "2. Kupup Lake – A unique, elephant-shaped lake surrounded by scenic beauty.", "3. Old Baba Mandir – A revered shrine known for its spiritual significance.", "Later proceed to Gangtok"],
    images: [nathang],
    stay: "Gangtok",
    },
    {
    day: "04",
    route: "Nathang Valley → New Jalpaiguri or Bagdogra",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After breakfast, enjoy a smooth drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward travel. Your journey comes to a delightful end, leaving you with cherished memories of the breathtaking landscapes, serene mountain villages, and unforgettable experiences across Sikkim. From the winding roads of the historic Silk Route to the tranquil beauty of high-altitude valleys, this tour offers moments that will stay with you long after you return.",
    points: [""],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],
   "lachen-&-gurudongmar-lake": [
    {
    day: "01",
    route: "NEW JALPAIGURI OR BAGDOGRA → GANGTOK",
    title: "GANGTOK",
    description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, and proceed to the beautiful hill town of Gangtok, the capital city of Sikkim. The journey takes approximately 4–5 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: ["Evening free to explore:", "1. M.G. Marg - A popular walking street known for its shops, cozy cafés, and lively nightlife."],
    images: [gtk],
    stay: "Gangtok",
    },
    {
    day: "02",
    route: "GANGTOK → LACHEN",
    title: "LACHEN",
    description: "After an early morning departure from Gangtok, embark on a scenic drive to Lachen, a charming mountain village nestled in North Sikkim. The journey takes approximately 6–7 hours, covering around 120 km through picturesque Himalayan landscapes, winding roads, and lush valleys.",
    points: [
    "En-route Sightseeing:",
    "1. Seven Sisters Waterfall – A stunning multi-stream waterfall cascading down rocky cliffs.",
    "2. Naga Waterfall – A scenic roadside waterfall, perfect for a short stop and photos.",
    "3. Chungthang – A beautiful confluence of rivers with spiritual and natural significance."
    ],
    images: [chunthang],
    stay: "Lachen",
    },
    {
    day: "03",
    route: "LACHEN → GURUDONGMAR LAKE",
    title: "GURUDONGMAR LAKE",
    description: "After an early wake-up around 3:30–4:00 AM, proceed for a breathtaking excursion to Gurudongmar Lake, one of the highest lakes in the world, situated at an altitude of approximately 17,800 ft. This sacred lake holds great religious significance for both Buddhists and Sikhs and offers mesmerizing views of the surrounding snow-covered mountains.",
    points: [
    "Important Alert: Due to the high altitude and low oxygen levels, visitors are advised to avoid physical exertion and limit their stay to about 20–30 minutes."
    ],
    images: [gurudongmar],
    stay: "Lachen",
    },
    {
    day: "04",
    route: "LACHEN → GANGTOK",
    title: "GANGTOK",
    description: "After breakfast, proceed on a scenic drive back to Gangtok, enjoying the picturesque Himalayan landscapes and winding mountain roads along the way. Arrive in Gangtok by evening, concluding the journey with memorable views of the region's natural beauty.",
    points: [],
    images: [lachen],
    stay: "Gangtok",
    },
    {
    day: "05",
    route: "GANGTOK → NEW JALPAIGURI OR BAGDOGRA",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After a memorable day exploring the snow-clad hills, enjoy a comfortable drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward journey. Your journey through North Sikkim comes to a memorable conclusion, leaving you with unforgettable experiences of breathtaking landscapes, serene mountain villages.",
    points: [
    "From the enchanting valleys of Lachen and mesmerizing Gurudongmar Lake, every moment offers a perfect blend of adventure and tranquility."
    ],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],
   "lachung-&-yumthang-valley": [
    {
    day: "01",
    route: "NEW JALPAIGURI OR BAGDOGRA → GANGTOK",
    title: "GANGTOK",
    description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, and proceed to the beautiful hill town of Gangtok, the capital city of Sikkim. The journey takes approximately 4–5 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: ["Evening free to explore:", "1. M.G. Marg - A popular walking street known for its shops, cozy cafés, and lively nightlife."],
    images: [gtk],
    stay: "Gangtok",
    },
    {
    day: "02",
    route: "GANGTOK → LACHUNG",
    title: "LACHUNG",
    description: "Begin your journey early in the morning from Gangtok and drive towards the picturesque mountain village of Lachung. The route covers approximately 115 km and takes around 6–7 hours, offering breathtaking views of rivers, valleys, and winding mountain roads.",
    points: [
    "En-route Sightseeing:",
    "1. Seven Sisters Waterfall – A stunning multi-stream waterfall cascading down rocky cliffs.",
    "2. Naga Waterfall – A scenic roadside waterfall, perfect for a short stop and photos.",
    "3. Chungthang – A beautiful confluence of rivers with spiritual and natural significance."
    ],
    images: [lachung],
    stay: "Lachung",
    },
    {
    day: "03",
    route: "LACHUNG → YUMTHANG",
    title: "YUMTHANG",
    description: "After an early breakfast, proceed for a scenic excursion to Yumthang Valley, one of the most beautiful destinations in North Sikkim. Popularly known as the “Valley of Flowers”, this breathtaking valley is best visited during spring (April–June) when colorful flowers are in full bloom. Surrounded by snow-capped peaks and flowing rivers, it offers a truly mesmerizing experience.",
    points: [
    "Sightseeing:",
    "1. Hot Spring – Located Near Yumthang Valley, A Short Walk Leads To Natural Hot Springs Known For Their Therapeutic Properties.",
    "2. Zero Point (At Extra Cost) – Situated At An Altitude Of Approximately 15,300 Ft, This High-Altitude Destination Remains Snow-Covered For Most Of The Year And Offers Spectacular Views."
    ],
    images: [zeropoint],
    stay: "Lachung",
    },
    {
    day: "04",
    route: "YUMTHANG → GANGTOK",
    title: "GANGTOK",
    description: "After breakfast, proceed on a scenic drive back to Gangtok, enjoying the picturesque Himalayan landscapes and winding mountain roads along the way. Arrive in Gangtok by evening, concluding the journey with memorable views of the region's natural beauty.",
    points: [],
    images: [yumthang],
    stay: "Gangtok",
    },
    {
    day: "05",
    route: "GANGTOK → NEW JALPAIGURI OR BAGDOGRA",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After a memorable day exploring the snow-clad hills, enjoy a comfortable drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward journey. Your journey through North Sikkim comes to a memorable conclusion, leaving you with unforgettable experiences of breathtaking landscapes, serene mountain villages.",
    points: ["From the enchanting valleys of Lachung and Yumthang to the thrilling high-altitude views of Zero Point, every moment offers a perfect blend of adventure and tranquility."],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],
   "south-&-west": [
    {
    day: "01",
    route: "NEW JALPAIGURI OR BAGDOGRA → PELLING",
    title: "PELLING",
    description: "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport, and proceed to the beautiful place known as Pelling. The journey takes approximately 5–6 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: ["Evening free to explore:", "1. Pelling - Enjoy a relaxing evening with a beautiful sunset view."],
    images: [tsomgoImg],
    stay: "Pelling",
    },
    {
    day: "02",
    route: "PELLING",
    title: "PELLING SIGHT SEEING",
    description: "After breakfast, proceed to explore the major attractions of Pelling, experiencing its scenic viewpoints, cultural landmarks, and natural beauty. This sightseeing tour offers a perfect opportunity to enjoy panoramic views of the surrounding mountains, visit renowned monasteries, and discover the rich heritage of the region, making your day both memorable and enriching.",
    points: [
    "En-route Sightseeing:",
    "1. Sky Walk, Pelling – India's first glass skywalk, offering a thrilling experience as visitors walk on a transparent platform with stunning views of the surrounding valleys and mountains.",
    "2. Chenrezig Statue – One of the tallest statues in Sikkim, offering panoramic views of the surrounding landscape",
    "3. Pemayangtse Monastery – One of the oldest and most significant monasteries in Sikkim, known for its rich heritage",
    "4. Rabdentse Ruins – The historic remains of the former capital of the Kingdom of Sikkim",
    "5. Khecheopalri Lake – A sacred lake, widely known as the “Wishing Lake” for its spiritual significance",
    "6. Rimbi Waterfalls – A picturesque natural attraction set amidst lush greenery, ideal for relaxation and photography"
    ],
    images: [skywalk1, rimbi, Khecheopalri],
    stay: "Pelling",
    },
    {
    day: "03",
    route: "PELLING → RAVANGLA",
    title: "RAVANGLA",
    description: "After breakfast, proceed with a scenic drive to the peaceful town of Ravangla. Upon arrival, enjoy a local sightseeing tour covering Tathagata Tsal and Ralang Monastery. Later, spend some leisure time soaking in the calm Himalayan surroundings before continuing with your onward journey.",
    points: [
    "Sightseeing:",
    "1. Tathagata Tsal – Renowned For Its Magnificent Giant Buddha Statue, Offering Breathtaking Panoramic Views Of The Surrounding Mountains.",
    "2. Ralang Monastery – A Serene Monastery Where Visitors Can Experience The Peaceful And Calming Himalayan Atmosphere."
    ],
    images: [ralang, buddha],
    stay: "Ravangla",
    },
    {
    day: "04",
    route: "RAVANGLA → NAMCHI",
    title: "NAMCHI",
    description: "After breakfast, proceed with a scenic drive to the charming town of Namchi. Upon arrival, enjoy a local sightseeing tour covering Siddheshwar Dham and Samdruptse Statue. Later, spend some leisure time enjoying the serene surroundings before continuing with your onward journey.",
    points: [
    "Sightseeing:",
    "1. Siddheshwar Dham – It is also known as Char Dham which is a revered pilgrimage site featuring replicas of India's sacred Char Dham temples.",
    "2. Samdruptse Statue – One of the tallest statues of Guru Padmasambhava, symbolizing peace and spiritual significance."
    ],
    images: [chardham, samdruptse],
    stay: "Namchi",
    },
    {
    day: "05",
    route: "NAMCHI → NEW JALPAIGURI OR BAGDOGRA",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description: "After a memorable day exploring the snow-clad hills, enjoy a comfortable drop-off at New Jalpaiguri Railway Station or Bagdogra Airport for your onward journey. Your journey concludes on a delightful note, leaving you with cherished memories of the scenic beauty and cultural richness of South and West Sikkim.",
    points: ["From the spiritual charm of Namchi and Ravangla to the breathtaking landscapes of Pelling, this tour offers a perfect blend of tranquility, heritage, and natural beauty that stays with you long after your return."],
    images: [airport],
    stay: "Drop-off at your station or airport",
    },
  ],
   "darjeeling": [
    {
    day: "01",
    route: "NEW JALPAIGURI OR BAGDOGRA → DARJEELING",
    title: "NEW DARJEELING",
    description: "Upon arrival, you will be warmly received and assisted with your transfer to Darjeeling. On reaching Darjeeling, proceed with a smooth hotel check-in and take some time to freshen up and relax after your journey.",
    points: [
    "Sight seeing:",
    "1. Himalayan Mountaineering Institute – A premier institute and museum dedicated to mountaineering, established in honor of Tenzing Norgay.",
    "2. Padmaja Naidu Himalayan Zoological Park – A high-altitude zoo known for conserving rare Himalayan animals like the red panda and snow leopard.",
    "3. Peace Pagoda – A Buddhist stupa promoting peace, offering serene surroundings and panoramic views of Darjeeling.",
    "Evening walk:",
    "Chowrasta - The main public square of Darjeeling, known for its lively atmosphere, scenic views, local shops, and a popular spot for leisurely walks and relaxation."
    ],
    images: [peace, zoo],
    stay: "Darjeeling",
    },
    {
    day: "02",
    route: "DARJEELING → TIGER HILL",
    title: "TIGER HILL",
    description: "Begin your day early in the morning around 4 AM with a visit to Tiger Hill. Witness the breathtaking sunrise as the first rays of light illuminate the majestic Kanchenjunga peaks. Enjoy the serene atmosphere and panoramic views, creating an unforgettable start to your day.",
    points: [
    "While returning:",
    "1. Bastasia Loop - Visit Batasia Loop, a unique spiral railway track offering stunning panoramic views of the surrounding hills and the Kanchenjunga range.",
    "2. Ghoom Monastery - One of the oldest monasteries in the region, known for its peaceful ambiance and impressive statue of Maitreya Buddha.",
    "After breakfast:",
    "1. Happy Valley Tea Estate - One of the oldest and most renowned tea gardens in Darjeeling, where you can witness the tea-making process, stroll through lush green plantations, and enjoy the serene charm of the surrounding hills."
    ],
    images: [batasia, ghoom],
    stay: "Drop-off at your station or airport",
    },
  ],
   "09-days-all-sikkim": [
  {
    day: "01",
    route: "NEW JALPAIGURI OR BAGDOGRA → GANGTOK",
    title: "GANGTOK",
    description:
      "Enjoy a comfortable pickup from New Jalpaiguri Railway Station or Bagdogra Airport and proceed to the beautiful hill town of Gangtok, the capital city of Sikkim. The journey takes approximately 4–5 hours and offers glimpses of scenic landscapes and winding mountain roads.",
    points: [
      "Evening free to explore:",
      "1. M.G. Marg - A popular walking street known for its shops, cozy cafés, and lively nightlife."
    ],
    images: [gtk],
    stay: "Overnight stay at Gangtok",
  },

  {
    day: "02",
    route: "GANGTOK → LACHUNG",
    title: "LACHUNG",
    description:
      "Begin your journey early in the morning from Gangtok and drive towards the picturesque mountain village of Lachung. The route covers approximately 115 km and takes around 6–7 hours, offering breathtaking views of rivers, valleys, and winding mountain roads.",
    points: [
      "En-route Sightseeing:",
      "1. Seven Sisters Waterfall – A stunning multi-stream waterfall.",
      "2. Naga Waterfall – A scenic roadside waterfall, perfect for a short stop and photos.",
      "3. Chungthang – A beautiful confluence of rivers with spiritual and natural significance."
    ],
    images: [chunthang],
    stay: "Overnight stay at Lachung",
  },

  {
    day: "03",
    route: "LACHUNG → YUMTHANG VALLEY → ZERO POINT",
    title: "YUMTHANG VALLEY",
    description:
      "After an early breakfast, proceed for a scenic excursion to Yumthang Valley, one of the most beautiful destinations in North Sikkim. Popularly known as the 'Valley of Flowers', this breathtaking valley is best visited during spring (April–June) when colorful flowers are in full bloom. Surrounded by snow-capped peaks and flowing rivers, it offers a truly mesmerizing experience.",
    points: [
      "Guests may also opt to visit Yumesamdong (Zero Point) at an additional cost, located near the Indo-China border, where snow can be experienced almost throughout the year.",
      "Later, return to Lachung for lunch and continue your journey towards Lachen, a serene Himalayan village."
    ],
    images: [yumthang],
    stay: "Overnight stay at Lachen",
  },

  {
    day: "04",
    route: "YUMTHANG VALLEY → GURUDONGMAR LAKE",
    title: "GURUDONGMAR LAKE",
    description:
      "Begin your day with an early morning excursion to the spectacular Gurudongmar Lake, one of the highest lakes in the world, situated at an altitude of approximately 17,800 ft. This sacred lake, set amidst majestic snow-clad mountains, offers breathtaking panoramic views and a truly unforgettable Himalayan experience.",
    points: [
      "After the visit, return to Lachen and later proceed back towards Gangtok through scenic mountain roads."
    ],
    images: [gurudongmar],
    stay: "Overnight stay at Gangtok",
  },

  {
    day: "05",
    route: "GURUDONGMAR LAKE → TSOMGO LAKE & NATHULA PASS",
    title: "TSOMGO LAKE & NATHULA PASS",
    description:
      "Embark on an early morning excursion to explore high-altitude attractions, where you can experience breathtaking mountain views, fresh crisp air, and the serene beauty of the Himalayan landscape.",
    points: [
      "Attractions:",
      "1. Tsomgo Lake (also called Changu Lake) – A beautiful glacial lake located at 12,400 ft.",
      "2. Nathula Pass – Historic mountain pass on the Indo-China border.",
      "3. Baba Harbhajan Singh Temple – A revered shrine dedicated to an Indian Army soldier believed to safeguard and protect the region."
    ],
    images: [tsomgo, nathula],
    stay: "Overnight stay at Gangtok",
  },

  {
    day: "06",
    route: "GANGTOK LOCAL SIGHT SEEING",
    title: "LOCAL SIGHT SEEING",
    description:
      "Gangtok local sightseeing offers a wonderful mix of natural beauty, peaceful temples, and cultural attractions.",
    points: [
      "Places of Sightseeing:",
      "1. Tashi View Point – Offers stunning panoramic views of the majestic Kanchenjunga mountain range, especially during sunrise.",
      "2. Ganesh Tok and Hanuman Tok – Peaceful temples dedicated to Lord Ganesha and Lord Hanuman, known for their calm surroundings and beautiful views of Gangtok city.",
      "3. Enchey Monastery – A historic Buddhist monastery known for its spiritual significance and traditional architecture.",
      "4. Namgyal Institute of Tibetology – A renowned center for Tibetan studies showcasing rare manuscripts, artifacts, and rich cultural heritage.",
      "5. Do Drul Chorten – One of the most important stupas in Gangtok, surrounded by prayer wheels and known for its religious importance.",
      "6. Banjhakri Falls – A beautiful waterfall set amidst landscaped gardens associated with local shamanic traditions and folklore."
    ],
    images: [tashi,ganesh],
    stay: "Overnight stay at Gangtok",
  },

  {
    day: "07",
    route: "GANGTOK → NAMCHI & RAVANGLA",
    title: "NAMCHI & RAVANGLA",
    description:
      "After breakfast, proceed with a scenic drive to the charming town of Namchi. Upon arrival, enjoy local sightseeing including Siddheshwar Dham and Samdruptse Statue. Later, continue your journey towards Ravangla and visit popular attractions surrounded by serene Himalayan landscapes.",
    points: [
      "1. Siddheshwar Dham – A famous pilgrimage and cultural site featuring replicas of important Jyotirlingas and Char Dham temples.",
      "2. Samdruptse Statue – One of the tallest statues of Guru Padmasambhava offering panoramic views.",
      "3. Buddha Park Ravangla – A peaceful park featuring a magnificent Buddha statue surrounded by lush greenery."
    ],
    images: [chardham],
    stay: "Overnight stay at Gangtok",
  },

  {
    day: "08",
    route: "NAMCHI & RAVANGLA → PELLING",
    title: "PELLING",
    description:
      "After breakfast, proceed to explore the major attractions of Pelling, experiencing its scenic viewpoints, cultural landmarks, and natural beauty. This sightseeing tour offers a perfect opportunity to enjoy panoramic mountain views, visit renowned monasteries, and discover the rich heritage of the region.",
    points: [
      "En-route Sightseeing:",
      "1. Sky Walk Pelling – India’s first glass skywalk offering thrilling mountain views.",
      "2. Chenrezig Statue – One of the tallest statues in Sikkim with breathtaking surroundings.",
      "3. Pemayangtse Monastery – One of the oldest and most significant monasteries in Sikkim.",
      "4. Rabdentse Ruins – Historic remains of the former capital of the Kingdom of Sikkim.",
      "5. Khecheopalri Lake – A sacred lake also known as the 'Wishing Lake'.",
      "6. Rimbi Waterfalls – A picturesque waterfall surrounded by lush greenery."
    ],
    images: [skywalk1, Khecheopalri, rimbi],
    stay: "Overnight stay at Pelling",
  },

  {
    day: "09",
    route: "PELLING → NEW JALPAIGURI OR BAGDOGRA",
    title: "NEW JALPAIGURI / BAGDOGRA",
    description:
      "Your journey comes to a memorable close as you depart with cherished impressions of Sikkim’s diverse landscapes and cultural richness. From the lively streets of Gangtok and the scenic charm of Lachung to the breathtaking beauty of Yumthang Valley and the majestic heights of Gurudongmar Lake, each destination offers a unique experience.",
    points: [
      "The serene waters of Tsomgo Lake and the historic Nathula Pass add to the adventure, while local sightseeing in Gangtok, Namchi, Ravangla, and Pelling showcase the region’s spiritual heritage and natural elegance."
    ],
    images: [airport],
    stay: "Drop-off at your station or airport",
  },
],
};